export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "TransporterMasterImportWorker.d6418f29f59ca53a85ea.worker.js");
}
